export default __webpack_public_path__ + "static/media/56.016c2784.png";